import script from "./FAQUnit.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQUnit.vue?vue&type=script&setup=true&lang=ts"

import "./FAQUnit.vue?vue&type=style&index=0&id=099949aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-099949aa"]])

export default __exports__